export default "__VITE_ASSET__D892XivW__"